<template>
  <div class="section">
    <div class="row">
      <div class="col card text-left">
        <div v-if="success" class="alert alert-success" role="alert">
          <strong>¡Éxito!</strong> Revisa tu bandeja de entrada para validar tu correo electrónico.
          <button type="button" class="close" data-dismiss="alert" aria-label="Close" v-on:click="goBack()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
         <div class="card-body">
          <h5 class="card-title">Recuperar contraseña</h5>

          <form v-on:submit="submit" method="post">
            <div class="form-group mt-5">
              <input  required type="email" v-model="username" class="form-control" id="input-email" aria-describedby="email-help" placeholder="Correo electrónico">
              <small id="email-help" class="form-text text-muted">Ingresa el correo electrónico con el cual inicias sesión.</small>
            </div>
            <div class="form-group d-flex justify-content-between">
              <button class="btn btn-clear" v-on:click="goBack()">Atrás</button>
              <button class="btn btn-primary" type="submit">Enviar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recoverPassword',
  created() {
    // this.$store.commit('clearData');
  },
  methods: {
    goBack: function() {
      this.$router.back();
    },
    submit: function(event) {
      let self = this;
      event.preventDefault();
      let url = this.$store.state.connection.url;
      const payload = {
        params: {
          login: this.username,
        },
      };
      this.$http.post(url + 'reset', payload)
      .then((result) => {
        self.success = true;
      })
      .catch((err) => {
        console.error(err);
      });
    }
  },
  components: {
  },
  data: function() {return {
    username: '',
    success: false,
  }},
}
</script>

<style scoped>
  .login-view{
    display: flex;
    background-color: rgba(211, 99, 0, 0.7);
    background-image: url('../assets/background.jpg');
    box-shadow: inset 0 0 0 1000px rgba(211,99,0,.7);
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    min-height: 100vh;
  }
  section{
    color: #ffffff !important;
  }
  .login-view .btn-link{
  color: #fff !important;
  font-size: 14px !important;
  }
 .login-view .btn, .login-view form, .login-view .card{
  color: #fff !important;
  font-size: 14px !important;
  }
  .login-view .text-muted{
  color: #fff !important;
  }
  .login-view .btn-primary{
  background-color: transparent !important;
  border-color: #fff;
  }
  input{
  background-color: rgba(255, 255, 255, 0.25) !important;
  color: #fff !important;
  font-size: 16px;
  padding: 20px;
}
.input-group-text{
  background-color: rgba(255, 255, 255, 0.25) !important;
}
::-webkit-input-placeholder { /* Chrome */
  color: #fff !important;
  opacity: 1 !important;
  font-size: 16px;
}
::placeholder { /* Chrome */
  color: #fff !important;
  opacity: 1 !important;
  font-size: 16px;
}
</style>
